// LUMINA · pages/vajra/admin/TeachersSection.jsx
// Phase 39D: extracted from AdminHub.jsx — 上师管理 (teacher CRUD)

import React, { useState } from 'react';
import { API, GD, TXT, TXT2, PANEL } from '../constants';
import ImageUpload from '../../../components/ImageUpload';
import { VajraBtn } from '../primitives';

const BLANK_TEACHER = {name_zh:"",name_en:"",tradition:"",lineage:"",bio_zh:"",bio_en:"",photo_url:"",website:"",is_featured:false};

export default function TeachersSection({ token, headers, teacherList, setTeacherList }) {
  const [teacherForm, setTeacherForm] = useState(BLANK_TEACHER);
  const [editTeacherId, setEditTeacherId] = useState(null);
  const [teacherMsg, setTeacherMsg] = useState("");

  const loadTeachers = async () => {
    const d = await fetch(`${API}/vajra/teachers`).then(r=>r.ok?r.json():[]).catch(()=>[]);
    setTeacherList(Array.isArray(d)?d:[]);
  };

  return (
    <div style={{background:PANEL,borderRadius:12,padding:"20px",border:`1px solid rgba(0,0,0,0.06)`}}>
      <div style={{fontSize:14,color:GD,marginBottom:4}}>上师管理</div>
      <div style={{fontSize:11,color:"#aaa",marginBottom:16}}>添加、编辑、删除上师档案。法会与法教均可关联到上师。</div>
      {teacherMsg&&<div style={{fontSize:13,padding:"8px 12px",borderRadius:8,marginBottom:12,background:teacherMsg.startsWith("✗")?"rgba(220,38,38,0.08)":"rgba(5,150,105,0.08)",color:teacherMsg.startsWith("✗")?"#dc2626":"#059669"}}>{teacherMsg}</div>}

      {/* Teacher form */}
      <form onSubmit={async e=>{
        e.preventDefault();
        const url = editTeacherId ? `${API}/vajra/staff/teachers/${editTeacherId}` : `${API}/vajra/staff/teachers`;
        const method = editTeacherId ? "PUT" : "POST";
        const r = await fetch(url,{method,headers:{...headers,"Content-Type":"application/json"},body:JSON.stringify({...teacherForm,teacher_id:undefined})});
        if(r.ok){ setTeacherMsg(editTeacherId?"✓ 上师信息已更新":"✓ 上师已添加"); setEditTeacherId(null); setTeacherForm(BLANK_TEACHER); loadTeachers(); }
        else { const d=await r.json(); setTeacherMsg("✗ "+(d.detail||"操作失败")); }
      }} style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:20,padding:"14px 16px",background:"rgba(212,175,55,0.04)",borderRadius:10,border:`1px solid rgba(212,175,55,0.15)`}}>
        <div style={{gridColumn:"1/-1",fontSize:12,color:GD,fontWeight:600,marginBottom:4}}>{editTeacherId?"编辑上师":"添加上师"}</div>
        {[["name_zh","中文名称 *","如：拉则祖古仁波切"],["name_en","英文名称","如：Lama Kunsang Rinpoche"],
          ["tradition","门派","噶举 / 宁玛 / 格鲁 / 萨迦"],["lineage","传承","止贡 / 白玉 / 竹巴 / 色达"],
          ["website","官网","https://..."]].map(([k,label,ph])=>(
          <div key={k}>
            <label style={{fontSize:10,color:"#aaa",letterSpacing:1,display:"block",marginBottom:3}}>{label}</label>
            <input value={teacherForm[k]||""} onChange={e=>setTeacherForm({...teacherForm,[k]:e.target.value})}
              placeholder={ph} required={k==="name_zh"}
              style={{width:"100%",padding:"7px 10px",border:"1px solid rgba(0,0,0,0.12)",borderRadius:7,fontSize:13,background:"#fff",boxSizing:"border-box"}}/>
          </div>
        ))}
        <div style={{gridColumn:"1/-1",marginTop:4}}>
          <label style={{fontSize:10,color:"#aaa",letterSpacing:1,display:"block",marginBottom:5}}>头像图片</label>
          <ImageUpload
            currentUrl={teacherForm.photo_url}
            onUpload={(url) => setTeacherForm({...teacherForm, photo_url: url})}
            label="上传承师头像"
          />
          {teacherForm.photo_url && (
            <input value={teacherForm.photo_url} onChange={e=>setTeacherForm({...teacherForm,photo_url:e.target.value})}
              placeholder="或直接输入URL" style={{width:"100%",padding:"6px 10px",border:"1px solid rgba(0,0,0,0.12)",borderRadius:7,fontSize:11,color:"#888",boxSizing:"border-box",marginTop:6}}/>
          )}
        </div>
        <div style={{gridColumn:"1/-1"}}>
          <label style={{fontSize:10,color:"#aaa",letterSpacing:1,display:"block",marginBottom:3}}>简介（中文）</label>
          <textarea value={teacherForm.bio_zh||""} onChange={e=>setTeacherForm({...teacherForm,bio_zh:e.target.value})}
            placeholder="上师简介..." rows={3}
            style={{width:"100%",padding:"7px 10px",border:"1px solid rgba(0,0,0,0.12)",borderRadius:7,fontSize:13,background:"#fff",boxSizing:"border-box",resize:"vertical"}}/>
        </div>
        <div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",gap:10}}>
          <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:TXT,cursor:"pointer",userSelect:"none"}}>
            <input type="checkbox" checked={!!teacherForm.is_featured}
              onChange={e=>setTeacherForm({...teacherForm,is_featured:e.target.checked})}
              style={{accentColor:GD,width:15,height:15}}/>
            首页精选展示
          </label>
        </div>
        <div style={{gridColumn:"1/-1",display:"flex",gap:8}}>
          <VajraBtn variant="green" type="submit" style={{flex:1}}>{editTeacherId?"保存修改":"添加上师"}</VajraBtn>
          {editTeacherId&&<VajraBtn variant="outline" onClick={()=>{setEditTeacherId(null);setTeacherForm(BLANK_TEACHER);}}>取消</VajraBtn>}
        </div>
      </form>

      {/* Teacher list */}
      {teacherList.length === 0 ? (
        <div style={{fontSize:13,color:"#ccc",textAlign:"center",padding:"20px 0"}}>暂无上师记录</div>
      ) : teacherList.map(t=>(
        <div key={t.id} style={{display:"flex",gap:12,padding:"12px 14px",marginBottom:8,borderRadius:10,
          background:"rgba(255,255,255,0.7)",border:`1px solid rgba(212,175,55,0.15)`,alignItems:"flex-start"}}>
          {t.photo_url && <img src={t.photo_url} alt={t.name_zh} style={{width:48,height:48,borderRadius:"50%",objectFit:"cover",flexShrink:0}}/>}
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:600,fontSize:14,color:TXT}}>{t.name_zh}{t.name_en&&<span style={{fontSize:12,color:TXT2,marginLeft:6}}>{t.name_en}</span>}{t.is_featured&&<span style={{fontSize:10,color:GD,marginLeft:8,background:"rgba(212,175,55,0.12)",border:"1px solid rgba(212,175,55,0.3)",borderRadius:8,padding:"1px 7px"}}>首页精选</span>}</div>
            <div style={{fontSize:12,color:TXT2,marginTop:2}}>
              {t.tradition&&<span style={{background:`rgba(212,175,55,0.1)`,border:`1px solid rgba(212,175,55,0.3)`,borderRadius:8,padding:"1px 8px",marginRight:6,fontSize:11}}>{t.tradition}</span>}
              {t.lineage&&<span style={{background:`rgba(212,175,55,0.06)`,border:`1px solid rgba(212,175,55,0.2)`,borderRadius:8,padding:"1px 8px",fontSize:11}}>{t.lineage}</span>}
            </div>
            {t.bio_zh&&<div style={{fontSize:12,color:"#888",marginTop:4,lineHeight:1.5,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{t.bio_zh}</div>}
            {t.website&&<a href={t.website} target="_blank" rel="noopener noreferrer" style={{fontSize:11,color:GD,marginTop:2,display:"block"}}>{t.website}</a>}
          </div>
          <div style={{display:"flex",gap:6,flexShrink:0}}>
            <VajraBtn small variant="outline" onClick={()=>{ setEditTeacherId(t.id); setTeacherForm({name_zh:t.name_zh||"",name_en:t.name_en||"",tradition:t.tradition||"",lineage:t.lineage||"",bio_zh:t.bio_zh||"",bio_en:t.bio_en||"",photo_url:t.photo_url||"",website:t.website||"",is_featured:!!t.is_featured}); window.scrollTo(0,0); }}>编辑</VajraBtn>
            <VajraBtn small variant="outline" onClick={async()=>{ if(!window.confirm(`确认删除 ${t.name_zh}？`)) return; const r=await fetch(`${API}/vajra/staff/teachers/${t.id}`,{method:"DELETE",headers}); if(r.ok){setTeacherMsg("✓ 已删除");loadTeachers();} }} style={{color:"#e57373",borderColor:"#e57373"}}>删除</VajraBtn>
          </div>
        </div>
      ))}
    </div>
  );
}
